import React from 'react';
import { dateToHistoricalDate, formatHistoricalYear } from '../utils/historicalDate';
import './EventDetail.css';

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const getImageUrl = (event) => {
  return event?.imageUrl || event?.imageURL || event?.image || '';
};

const getEventTags = (event) => {
  if (!Array.isArray(event?.tags)) return [];
  return event.tags
    .filter(tag => typeof tag === 'string')
    .map(tag => tag.trim())
    .filter(Boolean);
};

const formatHistoricalDate = (dateInput) => {
  try {
    const date = dateToHistoricalDate(dateInput);
    const month = MONTH_NAMES[date.month - 1] || `Month ${date.month}`;
    return `${month} ${date.day}, ${formatHistoricalYear(date)}`;
  } catch {
    return 'Invalid date';
  }
};

const EventDetail = ({ event, onClose, onEdit }) => {
  if (!event) return null;

  const isRange = event.type === 'range' && event.endDate;
  const imageUrl = getImageUrl(event);
  const title = typeof event.title === 'string' && event.title.trim() ? event.title.trim() : 'Untitled Event';
  const description = typeof event.description === 'string' ? event.description.trim() : '';
  const tags = getEventTags(event);

  return (
    <section className="event-detail" role="dialog" aria-modal="true" aria-label="Event details">
      <div className="event-detail-header">
        <div>
          <p className="event-detail-kicker">{isRange ? 'Range Event' : 'Point Event'}</p>
          <h2>{title}</h2>
        </div>
        <button type="button" className="event-detail-close" onClick={onClose} aria-label="Close event details">
          ×
        </button>
      </div>

      <dl className="event-detail-meta">
        <div>
          <dt>{isRange ? 'Start' : 'Date'}</dt>
          <dd>{formatHistoricalDate(event.date)}</dd>
        </div>
        {isRange && (
          <div>
            <dt>End</dt>
            <dd>{formatHistoricalDate(event.endDate)}</dd>
          </div>
        )}
      </dl>

      {imageUrl && (
        <figure className="event-detail-image">
          <img src={imageUrl} alt={title} />
        </figure>
      )}

      {description ? (
        <div className="event-detail-section">
          <h3>Description</h3>
          <p>{description}</p>
        </div>
      ) : (
        <p className="event-detail-empty">No description added.</p>
      )}

      {tags.length > 0 && (
        <div className="event-detail-section">
          <h3>Tags</h3>
          <div className="event-detail-tags">
            {tags.map(tag => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </div>
      )}

      <div className="event-detail-actions">
        <button type="button" data-tutorial-id="edit-event" onClick={onEdit}>Edit Event</button>
        <button type="button" className="secondary-button" onClick={onClose}>Close</button>
      </div>
    </section>
  );
};

export default EventDetail;
